import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo } from '@/mocks/data';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/services', label: '服务分类' },
    { to: '/articles', label: '体育资讯' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50 shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="container-custom flex items-center justify-between h-16 md:h-18">
        <Link to="/" className="flex items-center gap-2 no-underline">
          <div className="w-9 h-9 md:w-10 md:h-10 bg-primary-500 rounded-lg flex items-center justify-center">
            <i className="ri-medal-line text-xl text-background-50"></i>
          </div>
          <div className="flex flex-col leading-tight">
            <span className="text-lg md:text-xl font-bold text-foreground-900 font-heading">
              {siteInfo.name}
            </span>
            <span className={`text-xs transition-colors duration-300 ${scrolled ? 'text-foreground-600' : 'text-foreground-600'}`}>
              {siteInfo.tagline}
            </span>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === link.to
                  ? 'bg-primary-500 text-background-50'
                  : scrolled
                  ? 'text-foreground-700 hover:bg-background-100'
                  : 'text-foreground-800 hover:bg-background-100/60'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/about"
            className="ml-3 px-5 py-2 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            立即咨询
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} ${scrolled ? 'text-foreground-900' : 'text-foreground-900'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
          <div className="container-custom py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.to
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="mt-2 px-4 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium text-center hover:bg-primary-600 transition-colors"
            >
              立即咨询
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}